
import React from "react";
import { Form, Radio, ConfigProvider } from 'antd';

const NewRadioField = (props) => (
    <ConfigProvider direction="rtl">
        <Form.Item name={props.name} label={props.label} labelCol={{ span: 24 }}
            rules={[
                {
                    required: true,
                    message: `لطفا ${props.label} خود را وارد نمایید!`,
                },
            ]}
        >
            <Radio.Group  buttonStyle="solid" block style={{'width':'101%'}}  onChange={(props)?props.handleParent:null}>
                <Radio.Button value="7" style={{width:'40%'}}>فعال سازی گارانتی</Radio.Button>
                <Radio.Button value="2" style={{width:'30%'}}>تعمیر</Radio.Button>            
                <Radio.Button value="3"style={{width:'30%'}}>نصب</Radio.Button>
            </Radio.Group>

        </Form.Item>
    </ConfigProvider>
);

export default NewRadioField;